import Vue from "vue"
import JsonCSV from "vue-json-csv"

import Datepicker from "@/components/core/Datepicker"
import APITable from "@/components/core/APITable"

Vue.component("datepicker", Datepicker)
Vue.component("api-table", APITable)
Vue.component("download-csv", JsonCSV)
